/* eslint-disable react-hooks/exhaustive-deps */
import Logo from "../../assets/logo.png";
import styles from "./ResultBox.module.css";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import AdminAddresses from "./AdminAddresses";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CircularProgressBar from "../CircleProgress";

import { ROLE } from "../../utils/constant";
import { store } from "../../Context/Store";
import { NotificationManager } from "react-notifications";
import { AddNewSearchAddress, UpdateSearchAddress } from "../../API/Pins";
import { Fragment, useContext, useEffect, useState } from "react";

const ResultBox = (props) => {
  const context = useContext(store);
  const { state, dispatch } = context;

  const [editSelectedAddress, setEditSelectedAddress] = useState({
    latitude: 0,
    longitude: 0,
    raw_address: "",
    main_address: "",
    clean_address: "",
    exact_address: "",
    keyword_address: "",
  });

  const [AddAddress, setAddAddress] = useState({
    address: "",
    latitude: 0,
    longitude: 0,
  });

  const handleUpdateAddress = async () => {
    if (state.editMode) {
      try {
        const res = await UpdateSearchAddress({
          ...editSelectedAddress,
          id: state.selectedObject.id,
        });
        NotificationManager.success(res.data.result, "Success");
        dispatch({ type: "EDIT_MODE", state: false });
      } catch (error) {
        console.log(error);
      }
    }
    if (state.addAddressMode) {
      try {
        const res = await AddNewSearchAddress(AddAddress);
        NotificationManager.success(res.data.result, "Success");
      } catch (error) {
        console.log(error);
      }
      setAddAddress({
        address: "",
        latitude: 0,
        longitude: 0,
      });
    }
  };

  useEffect(() => {
    if (state.editMode) {
      setEditSelectedAddress({
        latitude: state.selectedObject?.latitude,
        longitude: state.selectedObject?.longitude,
        raw_address: state.selectedObject?.raw_address,
        main_address: state.selectedObject?.main_address,
        clean_address: state.selectedObject?.clean_address,
        exact_address: state.selectedObject?.exact_address,
        keyword_address: state.selectedObject?.keyword_address,
      });
    }
  }, [state.editMode]);

  useEffect(() => {
    if (state.editMode) {
      setEditSelectedAddress((prev) => ({
        ...prev,
        latitude: state.editedLocation[0],
        longitude: state.editedLocation[1],
      }));
    }
  }, [state.editedLocation]);

  useEffect(() => {
    if (state.addAddressMode) {
      setAddAddress((prev) => ({
        ...prev,
        latitude: state.addLocation[0],
        longitude: state.addLocation[1],
      }));
    }
  }, [state.addLocation]);

  const handleSelectLocation = () => {
    if (state.editMode) {
      dispatch({
        type: "FLY_TO_LOCATION",
        coords: [editSelectedAddress.latitude, editSelectedAddress.longitude],
      });
      dispatch({
        type: "CHANGE_LOCATION",
        location: [editSelectedAddress.latitude, editSelectedAddress.longitude],
      });
    }
    if (state.addAddressMode) {
      dispatch({
        type: "FLY_TO_LOCATION",
        coords: [AddAddress.latitude, AddAddress.longitude],
      });
      dispatch({
        type: "ADD_LOCATION",
        location: [AddAddress.latitude, AddAddress.longitude],
      });
    }
  };

  const handleRemoveBox = () => {
    dispatch({ type: "SET_LATLNG", latlng: [] });
  };

  return (
    <div className={[styles.wrapper, props.show && styles.show].join(" ")}>
      <div className={styles.optimeLogo}>
        <img src={Logo} alt="optime-ai" />
      </div>

      <div onClick={handleRemoveBox} className={styles.close}>
        +
      </div>

      {state.role === ROLE.MEMBER && !state.addAddressMode && (
        <span className={styles.editButton}>
          {state.editMode ? (
            <Fragment>
              <CheckIcon
                onClick={handleUpdateAddress}
                style={{
                  color: "white",
                  fontSize: "1.15rem",
                  position: "relative",
                  bottom: 2,
                }}
              />
              &nbsp; &nbsp;
              <HighlightOffIcon
                onClick={() => {
                  dispatch({ type: "EDIT_MODE", state: false });
                }}
                style={{ color: "white", fontSize: "1.3rem" }}
              />
            </Fragment>
          ) : (
            <EditIcon
              onClick={() => {
                dispatch({ type: "EDIT_MODE", state: true });
              }}
              style={{ color: "white", fontSize: "1.15rem" }}
            />
          )}
        </span>
      )}

      {state.addAddressMode && (
        <span onClick={handleUpdateAddress} className={styles.editButton}>
          Add New Address
        </span>
      )}

      {state.addAddressMode && (
        <div className={styles.Address}>
          <AdminAddresses
            setLocation={handleSelectLocation}
            Address={AddAddress}
            setAddress={setAddAddress}
            addAddress={true}
          />
        </div>
      )}

      {!!state.selectedAddress &&
        !!state.latlng.length &&
        !state.loadingAddress &&
        !state.notFound &&
        !state.addAddressMode && (
          <div className={styles.Address}>
            {!state.editMode ? (
              <Fragment>
                {state.selectedAddress}
                <br />
                <br />
              </Fragment>
            ) : (
              <AdminAddresses
                setLocation={handleSelectLocation}
                Address={editSelectedAddress}
                setAddress={setEditSelectedAddress}
              />
            )}
          </div>
        )}

      {!state.addAddressMode && !state.editMode && (
        <div className={styles.Address}>
          {parseFloat(
            state.editMode ? state.editedLocation[0] : state.latlng[0]
          ).toFixed(8)}
          ,
          {parseFloat(
            state.editMode ? state.editedLocation[1] : state.latlng[1]
          ).toFixed(8)}
        </div>
      )}

      {state.notFound && !state.addAddressMode && (
        <div className={styles.centerText}> Address Not Found </div>
      )}
      {state.loadingAddress && !state.addAddressMode && (
        <div className={styles.centerText}>
          Loading &nbsp; <CircularProgressBar size={30} color="#2080b8" />
        </div>
      )}
    </div>
  );
};

export default ResultBox;
